module.exports = __webpack_public_path__ + "media/images/3-empty-69162e5891f7abf348ff5388a1195bf3.png";